// utils/seoMappings.js
export const priestSeoDescriptions = {
  default: {
    title: "Book a Verified Pandit Online for All Hindu Pujas – Fast & Easy Booking",
    description:
      "Book a verified pandit online for all Hindu pujas. Enjoy hassle-free rituals at home with complete samagri and trusted priests across India.",
  },
  satyanarayan: {
    title: "Book Pandit for Satyanarayan Puja at Home – Full Vidhi & Setup",
    description:
      "Trusted pandits for Satyanarayan katha at home. Includes setup, mantras, and proper rituals with online booking.",
  },
  festival: {
    title: "Get a Trusted Online Pandit for Daily, Festival & Special Pujas",
    description:
      "Book online pandits for daily, festival, or special pujas. Multilingual priests and full samagri support available.",
  },
};

export const eventServicesSeoMappings = {
  default: {
    title: "Best event Organizer | Event planning| online Event Management service |thurent.in",
    description: "Looking to book an event organiser in Hyderabad? Plan and manage event services online with quick confirmation, smooth coordination and easy booking on thurent.in.",
    keywords: "event services, event organiser, event planning services, book event organiser, event services online, event management services, event organiser hyderabad, book event services hyderabad, thurent"
  },
  "event-organisers": {
    title: "Best event Organiser | Event planning service online | thurent.in",
    description: "Looking to book an event organiser in Hyderabad? Plan and manage event services online with quick confirmation, smooth coordination and easy booking on thurent.in. Hire expert event organisers for any occasion. Compare services, prices & book verified planners online at thurent.in.",
    keywords: "event services, event organiser, event planning services, book event organiser, event services online, event management services, event organiser hyderabad, book event services hyderabad, thurent"
  },
  "event-planning-companies": {
    title: "Best Event Planning Services Online | thurent.in",
    description: "Get popular event planning services for parties & corporate events etc. One trusted platform for complete planning – thurent.in.",
    keywords: "event organiser, event planning services, book event organiser, event services online, event management services, thurent"
  },
  "home-event-services": {
    title: "Top Home Event Services for Every Occasion | thurent.in",
    description: "Book top home event services including decor, catering & planning. Easy booking, trusted professionals only on thurent.in.",
    keywords: "event planning services, book event organiser, event services online, thurent"
  },
  "event-services-home": {
    title: "Event Services for Home Occasion | thurent.in",
    description: "Find complete event services for home parties and celebrations. Plan effortlessly and hire verified providers via thurent.in.",
    keywords: "book event organiser, event services online, event management services, thurent"
  },
  "corporate-event-planners": {
    title: "Professional Corporate Event Planners | thurent.in",
    description: "Hire expert corporate event planners for meetings, conferences & launches. Reliable planning and smooth execution with thurent.in.",
    keywords: "event services online, event management services, event organiser hyderabad, thurent"
  },
  "party-planners": {
    title: "Party Planners for All Events & Celebrations | thurent.in",
    description: "Looking for party planners? Book professionals for private parties & celebrations easily on thurent.in.",
    keywords: "event management services, event organiser hyderabad, book event services hyderabad, thurent"
  },
  "event-equipment-rental": {
    title: "Event Equipment Rental for Any Occasion | thurent.in",
    description: "Rent event equipment including lighting, sound systems & stage setup. Affordable pricing and quick booking on thurent.in.",
    keywords: "event organiser hyderabad, book event services hyderabad, thurent"
  },
  "event-planner-website": {
    title: "Event Planner Website to Book Services Online | thurent.in",
    description: "All-in-one event planner website to book planners, equipment & services. Simple, fast and reliable bookings on thurent.in.",
    keywords: "book event services hyderabad, thurent"
  },
  "event-furniture-rental": {
    title: "Event Furniture Rental for Parties & Events | thurent.in",
    description: "Book event furniture rentals including chairs, tables & decor items. Trusted vendors and easy booking only on thurent.in.",
    keywords: "thurent"
  }
};

export const eventbasedseomapping = {
  default: {
    title: "Best event Organiser | Event planning service online | thurent.in",
    description: "Looking to book an event organiser in Hyderabad? Plan and manage event services online with quick confirmation, smooth coordination and easy booking on thurent.in.",
    keywords: "event services, event organiser, event planning services, book event organiser, event services online, event management services, event organiser hyderabad, book event services hyderabad, thurent"
  }
}